:host {
  /**
   * @prop --color: Color of the card subtitle
   */
  display: block;
  position: relative;
  color: var(--color);
}

:host(.ion-color) {
  color: var(--ion-color-base);
}

:host {
  --color: var(--ion-color-step-600, #666666);
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
  margin-bottom: 4px;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}